import React, { useEffect, useState } from 'react';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';
import getPostBySlug from '../../../../api/graphql/queries/getPostBySlug';
import searchPosts from '../../../../api/graphql/queries/searchPosts';
import imageModifier from '../../../../utils/imageModifier';

const PostDescriptionRow = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'PostDescriptionRow',
    name: '',
    arrow: true,
    slugnames: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [posts, setPosts] = useState([]);
  const [selectedPosts, setSelectedPosts] = useState([]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
        setSelectedPostsFromDB(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const setSelectedPostsFromDB = async (comp) => {
    // eslint-disable-next-line no-restricted-syntax
    const postsArray = [];
    for (const slug of comp.slugnames) {
      await getPostBySlug(slug).then((res) => {
        postsArray.push(res.post);
      }).catch(err => console.log(err));
    }
    setSelectedPosts(postsArray);
  };

  const selectPostHandler = async (slugname) => {
    const componentObj = {
      id,
      component: state,
    };
    let newState = {};

    const postIndex = selectedPosts.findIndex(post => post.slugName === slugname);
    if (postIndex === -1) {
      await getPostBySlug(slugname).then((res) => {
        setSelectedPosts([...selectedPosts, res.post]);
        newState = {
          ...state,
          slugnames: [...state.slugnames, res.post.slugName],
        };
        setState(newState);
      }).catch(err => console.log(err));
    } else {
      const newPosts = selectedPosts;
      const newSlugs = state.slugnames;
      newPosts.splice(postIndex, 1);
      newSlugs.splice(postIndex, 1);
      setSelectedPosts([...newPosts]);
      newState = {
        ...state,
        slugnames: [...newSlugs],
      };
      setState(newState);
    }
    componentObj.component = newState;

    handlerSetComponents(componentObj, index);
    console.log('TCL: selectPostHandler -> componentObj, index', componentObj, index);
  };

  const searchPost = (e) => {
    const { value } = e.target;
    if (value === '') return setPosts([]);
    searchPosts(value)
      .then((res) => {
        if (res === null) return setPosts([]);
        setPosts(res);
      });
  };

  // useEffect(() => {
  //   getPostsByType('route').then((res) => {
  //     setPosts(res.posts.slice(0, 10));
  //   }).catch(err => console.log(err));
  // }, []);

  const trimDescription = (post) => {
    let description = post.substr(0, 35);
    description = description.substr(0, Math.min(description.length, description.lastIndexOf(' ')));
    return `${description}...`;
  };

  return (
    <div className="pl-8 flex justify-end flex-col">
      <div className={`bg-greyFilter h-16 w-full pl-6 flex flex-col rounded-r-lg ${posts.length > 0 && 'rounded-tr-lg rounded-br-none'}`}>
        <p className="text-xs uppercase pl-1 text-black font-americaMonoRegular mb-0 mt-0">Search</p>
        <input className="rounded-full pr-4 pl-9 py-2 mr-4 outline-none" type="text" onChange={searchPost} />
        <span className="font-icon icon-search z-5 text-black absolute mt-8 ml-2 text-sm" />
      </div>
      <div>
        {
         posts && posts.length > 0 ? (
           <div>
             <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg mr-4 ml-6 pl-5 mt-3 mb-0">Available posts</p>
             <div className="max-h-150 overflow-auto bg-greyFilterItems rounded-b-lg ml-6 mr-4 py-1 mb-3">
               {
                posts.map(element => (
                  element && (
                  <div onClick={() => selectPostHandler(element.slugName)} key={element.slugName}>
                    <p className="text-black font-americaMonoRegular outline-none w-full pl-6 my-1">{element.slugName }</p>
                  </div>
                  )
                ))
             }
             </div>
           </div>

         ) : null
        }
      </div>
      <div>
        {
           selectedPosts && selectedPosts.length ? (
             <div>
               <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg mr-4 ml-6 pl-5 mt-0 mb-0">Selected Posts</p>
               <div className="flex flex-row flex-wrap pl-2 pb-2 overflow-auto max-h-320 bg-greyFilterItems pt-0 mt-0 mb-4 ml-6 rounded-b-lg pb-1 pr-4 pt-2 mr-4 overflow-auto">
                 {
               selectedPosts.map(post => (
                 post ? (
                   <div className="flex justify-end rounded-t-lg" key={post.slugName}>
                     <div>
                       <div className="bg-greyFilter rounded m-8px pb-5 w-210px h-275px flex flex-col items-center pt-4 px-4 relative mt-5">
                         <span onClick={() => selectPostHandler(post.slugName)} className="font-icon icon-close-solid absolute text-black right-0 top-19neg" />
                         <img src={imageModifier(post.postDescription.image.en, '178x178')} alt={post.postDescription.image.en} />
                         <p className="text-black text-sm font-americaBlack bg-greyFilter outline-none w-full px-1 mb-0">
                           {post.postDescription.title.en.length > 35 ? trimDescription(post.postDescription.title.en) : post.postDescription.title.en}
                         </p>
                       </div>
                     </div>
                   </div>
                 ) : null
               ))
             }
               </div>
             </div>
           ) : null
        }


      </div>
    </div>
  );
};

export default PostDescriptionRow;
